import React, { useState, useEffect, useRef } from 'react';
import './Développement-Mobile.css';
import Header from '../Header/Header';
import Footer from '../footer/footer';
import { motion, AnimatePresence } from 'framer-motion';
import TopAnnouncementBar from '../TopAnnouncementBar/TopAnnouncementBar';
import WhatsAppButton from '../whatsapp/WhatsAppButton';
import { Link } from 'react-router-dom';
import { 
  FaRocket, 
  FaMobileAlt, 
  FaSearch, 
  FaShieldAlt,
  FaAndroid,
  FaApple,
  FaDatabase,
  FaArrowRight,
  FaCheckCircle,
  FaAward,
  FaUsers,
  FaClock,
  FaCode
} from 'react-icons/fa';
import { FaReact, FaSwift } from 'react-icons/fa';
import { SiKotlin, SiFlutter } from 'react-icons/si';
import { FiDatabase } from 'react-icons/fi';
import { MdAutoAwesome, MdOutlineSpeed, MdOutlineSupportAgent, MdPhoneIphone } from 'react-icons/md';
import { GiAstronautHelmet, GiStarsStack, GiGalaxy, GiSpiralShell, GiCrystalBall, GiCyberEye, GiArtificialIntelligence, GiThunderSkull, GiBrain, GiRocketThruster, GiSmartphone } from 'react-icons/gi';

const DeveloppementMobile = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isCursorActive, setIsCursorActive] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const sectionRef = useRef(null);
  let cursorTimeout;

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
      setIsCursorActive(true);
      
      clearTimeout(cursorTimeout);
      cursorTimeout = setTimeout(() => setIsCursorActive(false), 100);
    };
    
    const handleScroll = () => {
      if (sectionRef.current) {
        const rect = sectionRef.current.getBoundingClientRect();
        const scrollPercent = Math.min(1, Math.max(0, -rect.top / (rect.height - window.innerHeight)));
        setScrollProgress(scrollPercent);
      }
    };
    
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(cursorTimeout);
    };
  }, []);

  const solutionsData = [
    {
      title: "Applications iOS",
      tagline: "L'élégance Apple",
      description: "Des applications natives qui exploitent pleinement la puissance et l'élégance de l'écosystème Apple pour une expérience utilisateur incomparable.",
      features: ["Swift/SwiftUI natif", "Intégration iCloud", "FaceID/TouchID", "Performance optimale"],
      icon: <FaApple />,
      color: "#F05138",
      stat: "+98% de satisfaction"
    },
    {
      title: "Applications Android",
      tagline: "La puissance Google",
      description: "Des applications Android robustes qui atteignent des milliards d'utilisateurs avec une expérience fluide sur tous les appareils.",
      features: ["Kotlin/Jetpack Compose", "Material Design", "Compatibilité multi-appareils", "Play Store prêt"],
      icon: <FaAndroid />,
      color: "#3DDC84",
      stat: "2M+ utilisateurs potentiels"
    },
    {
      title: "Cross-Platform",
      tagline: "Un code, deux stores",
      description: "Développez simultanément pour iOS et Android avec une seule base de code, sans compromis sur la performance.",
      features: ["React Native / Flutter", "Code réutilisable", "UI native", "Mises à jour simultanées"],
      icon: <FaReact />,
      color: "#61DAFB",
      stat: "-50% de coûts"
    },
    {
      title: "Applications Hybrides",
      tagline: "Rapide & économique",
      description: "La solution idéale pour lancer rapidement votre application avec un budget maîtrisé, sans sacrifier l'essentiel.",
      features: ["Ionic/Capacitor", "WebView optimisée", "Accès aux capteurs", "Déploiement accéléré"],
      icon: <MdPhoneIphone />,
      color: "#10B981",
      stat: "Lancement en 6 semaines"
    }
  ];

  const benefits = [
    { icon: <FaApple />, title: "Expert iOS", description: "Swift & SwiftUI maîtrisés", color: "#F05138" },
    { icon: <FaAndroid />, title: "Expert Android", description: "Kotlin & Jetpack Compose", color: "#3DDC84" },
    { icon: <FaReact />, title: "React Native", description: "Cross-platform performant", color: "#61DAFB" },
    { icon: <SiFlutter />, title: "Flutter", description: "UI multi-plateforme", color: "#02569B" },
    { icon: <MdOutlineSpeed />, title: "Ultra-rapide", description: "< 2s de chargement", color: "#3B82F6" },
    { icon: <FaShieldAlt />, title: "Sécurité", description: "Données protégées", color: "#10B981" }
  ];

  const statsData = [
    { value: "150+", label: "apps livrées", icon: <FaRocket /> },
    { value: "4.9/5", label: "note moyenne", icon: <FaAward /> },
    { value: "98%", label: "satisfaction", icon: <FaUsers /> },
    { value: "24/7", label: "support prioritaire", icon: <FaClock /> }
  ];

  const technologies = [
    { icon: <FaSwift />, name: "Swift", color: "#F05138" },
    { icon: <SiKotlin />, name: "Kotlin", color: "#7F52FF" },
    { icon: <FaReact />, name: "React Native", color: "#61DAFB" },
    { icon: <SiFlutter />, name: "Flutter", color: "#02569B" },
    { icon: <FiDatabase />, name: "Firebase", color: "#FFCA28" },
    { icon: <FaDatabase />, name: "SQLite", color: "#3E6E93" }
  ];

  const getPreviewBadgeText = () => {
    switch(activeTab) {
      case 0: return "Native iOS pure performance";
      case 1: return "Expertise Android certifiée";
      case 2: return "Cross-platform haute performance";
      case 3: return "Rapide & économique";
      default: return "Solution premium";
    }
  };

  return (
    <div className="dm-container" ref={sectionRef}>
      <WhatsAppButton />
      <TopAnnouncementBar />
      <Header />
      
      {/* Cursor Glow */}
      <motion.div 
        className={`dm-cursor-glow ${isCursorActive ? 'active' : ''}`}
        animate={{
          x: mousePosition.x - 300,
          y: mousePosition.y - 300,
        }}
        transition={{ type: "spring", damping: 30, stiffness: 200, mass: 0.5 }}
      />

      {/* Particles */}
      <div className="dm-particles">
        {[...Array(60)].map((_, i) => (
          <div key={i} className="dm-particle" style={{
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 20}s`,
            animationDuration: `${20 + Math.random() * 30}s`,
            width: `${1.5 + Math.random() * 3}px`,
            height: `${1.5 + Math.random() * 3}px`,
          }} />
        ))}
      </div>

      {/* Animated Orbs */}
      <div className="dm-orbs">
        <div className="dm-orb dm-orb-1" style={{ transform: `translate(${scrollProgress * 100}px, ${scrollProgress * 50}px)` }} />
        <div className="dm-orb dm-orb-2" style={{ transform: `translate(-${scrollProgress * 80}px, -${scrollProgress * 60}px)` }} />
        <div className="dm-orb dm-orb-3" style={{ transform: `translate(${scrollProgress * 60}px, -${scrollProgress * 40}px)` }} />
        <div className="dm-orb dm-orb-4" style={{ transform: `translate(-${scrollProgress * 70}px, ${scrollProgress * 70}px)` }} />
      </div>

      {/* Floating Elements */}
      <div className="dm-floating">
        <GiGalaxy className="dm-float dm-float-1" />
        <GiSpiralShell className="dm-float dm-float-2" />
        <GiAstronautHelmet className="dm-float dm-float-3" />
        <GiStarsStack className="dm-float dm-float-4" />
        <GiCrystalBall className="dm-float dm-float-5" />
        <GiCyberEye className="dm-float dm-float-6" />
        <GiArtificialIntelligence className="dm-float dm-float-7" />
        <GiThunderSkull className="dm-float dm-float-8" />
        <GiBrain className="dm-float dm-float-9" />
        <GiRocketThruster className="dm-float dm-float-10" />
        <GiSmartphone className="dm-float dm-float-11" />
      </div>
      
      {/* ========== HERO BANNER ========== */}
      <section className="dm-hero">
        <div className="dm-hero-overlay"></div>
        <div className="dm-hero-inner">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="dm-hero-badge"
          >
            <GiSmartphone />
            <span>Mobile Development Excellence</span>
            <GiStarsStack />
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="dm-hero-title"
          >
            Des applications mobiles qui<br />
            <span className="dm-gradient-text">transforment l'expérience utilisateur</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="dm-hero-subtitle"
          >
            iOS, Android, Cross-Platform — nous créons des applications natives et hybrides 
            qui allient design premium, performance fulgurante et expérience utilisateur intuitive.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.3 }}
            className="dm-hero-buttons"
          >
            <Link to="/reservation-appel">
              <button className="dm-btn dm-btn-primary">
                <MdAutoAwesome /> Démarrer mon projet <FaArrowRight />
              </button>
            </Link>
            <Link to="/realisations">
              <button className="dm-btn dm-btn-secondary">
                <FaCode /> Explorer nos apps
              </button>
            </Link>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="dm-hero-stats"
          >
            {statsData.map((stat, idx) => (
              <div key={idx} className="dm-stat-card">
                <div className="dm-stat-icon">{stat.icon}</div>
                <div className="dm-stat-value">{stat.value}</div>
                <div className="dm-stat-label">{stat.label}</div>
              </div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* ========== BENEFITS SECTION ========== */}
      <section className="dm-benefits">
        <div className="dm-container-inner">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="dm-section-header"
          >
            <div className="dm-badge">Notre expertise mobile</div>
            <h2>L'excellence <span className="dm-gradient-text">sur chaque plateforme</span></h2>
            <p>Des applications qui brillent sur iOS, Android et au-delà</p>
          </motion.div>

          <div className="dm-benefits-grid">
            {benefits.map((benefit, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.05 }}
                whileHover={{ y: -8 }}
                className="dm-benefit-card"
                style={{ '--dm-card-color': benefit.color }}
              >
                <div className="dm-benefit-icon" style={{ color: benefit.color }}>{benefit.icon}</div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
                <div className="dm-benefit-glow" style={{ background: `radial-gradient(circle, ${benefit.color}20, transparent)` }} />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ========== SOLUTIONS SECTION - TABS ========== */}
      <section className="dm-solutions">
        <div className="dm-container-inner">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="dm-section-header"
          >
            <div className="dm-badge">Nos solutions</div>
            <h2>Des applications <span className="dm-gradient-text">sur mesure</span></h2>
            <p>iOS natif, Android pur, Cross-Platform — la technologie adaptée à vos besoins</p>
          </motion.div>

          {/* Tabs navigation */}
          <div className="dm-tabs-nav">
            {solutionsData.map((sol, idx) => (
              <button
                key={idx}
                className={`dm-tab-btn ${activeTab === idx ? 'active' : ''}`}
                onClick={() => setActiveTab(idx)}
                style={{ '--dm-tab-color': sol.color }}
              >
                <span className="dm-tab-icon">{sol.icon}</span>
                <span className="dm-tab-title">{sol.title}</span>
              </button>
            ))}
          </div>

          {/* Tab content */}
          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.4 }}
              className="dm-tab-content"
            >
              <div className="dm-tab-left">
                <div className="dm-solution-tagline" style={{ color: solutionsData[activeTab].color }}>
                  {solutionsData[activeTab].tagline}
                </div>
                <h3>{solutionsData[activeTab].title}</h3>
                <p>{solutionsData[activeTab].description}</p>
                <div className="dm-features-list">
                  {solutionsData[activeTab].features.map((feat, i) => (
                    <div key={i} className="dm-feature-item">
                      <FaCheckCircle style={{ color: solutionsData[activeTab].color }} />
                      <span>{feat}</span>
                    </div>
                  ))}
                </div>
                <div className="dm-solution-stat" style={{ background: `${solutionsData[activeTab].color}15`, borderLeftColor: solutionsData[activeTab].color }}>
                  <FaRocket />
                  <span><strong>{solutionsData[activeTab].stat}</strong></span>
                </div>
              </div>
              <div className="dm-tab-right">
                <div className="dm-preview-card" style={{ background: `linear-gradient(135deg, ${solutionsData[activeTab].color}10, rgba(10,17,40,0.4))` }}>
                  <div className="dm-preview-icon" style={{ color: solutionsData[activeTab].color }}>
                    {solutionsData[activeTab].icon}
                  </div>
                  <div className="dm-preview-badge">
                    {getPreviewBadgeText()}
                  </div>
                  <div className="dm-preview-stats">
                    <span>📱 Native</span>
                    <span>🔒 Sécurisée</span>
                    <span>⚡ Rapide</span>
                  </div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </section>

      {/* ========== TECHNOLOGIES SECTION ========== */}
      <section className="dm-tech">
        <div className="dm-container-inner">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="dm-section-header"
          >
            <div className="dm-badge">Stack technique</div>
            <h2>Les <span className="dm-gradient-text">meilleurs outils</span> pour vos apps</h2>
            <p>Nous sélectionnons les technologies les plus adaptées à vos objectifs</p>
          </motion.div>

          <div className="dm-tech-grid">
            {technologies.map((tech, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.05 }}
                whileHover={{ y: -5 }}
                className="dm-tech-card"
              >
                <div className="dm-tech-icon" style={{ color: tech.color }}>{tech.icon}</div>
                <h4>{tech.name}</h4>
                <div className="dm-tech-bar">
                  <div className="dm-tech-progress" style={{ backgroundColor: tech.color }} />
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ========== FINAL CTA ========== */}
      <section className="dm-final-cta">
        <div className="dm-cta-pattern"></div>
        <div className="dm-cta-inner">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="dm-cta-icon"
          >
            <GiRocketThruster />
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            Prêt à <span className="dm-gradient-text">concrétiser</span> votre projet mobile ?
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            Discutons de votre idée et transformons-la en application qui fera la différence.
          </motion.p>
          <Link to="/reservation-appel">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              className="dm-cta-button"
            >
              <MdAutoAwesome /> Obtenir un audit gratuit <FaArrowRight />
            </motion.button>
          </Link>
          <div className="dm-cta-features">
            <div><FaCheckCircle /> Réponse sous 24h</div>
            <div><FaShieldAlt /> Garantie satisfait</div>
            <div><FaUsers /> Support dédié</div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DeveloppementMobile;